import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Parameters from './Parameters';
import { useLocation } from 'react-router-dom';

function ParametersIndex(props) {
  const showMessage = (color, position, title, content) => {
    props.showMessage(color, position, title, content);
  };
  const location = useLocation();
  const routes = props.config.childs.map((r, index) => {
    return (
      <Route
        path={`/protected/admin${r.path}`}
        render={(props) => {
          return (
            <r.component {...props} config={r} showMessage={showMessage} />
          );
        }}
        key={index}
      />
    );
  });

  return (
    <>
      {`/protected/admin${props.config.path}` === location.pathname ? (
        <Parameters config={props.config} {...props} />
      ) : (
        <Switch>{routes}</Switch>
      )}
    </>
  );
}
export default ParametersIndex;
